import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

export default function BillingSuccessPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const qc = useQueryClient();

  useEffect(() => {
    // Invalidate billing cache so the new plan shows immediately on redirect
    qc.invalidateQueries({ queryKey: ["billing-usage"] });
    const t = setTimeout(() => navigate("/settings?tab=usage"), 3000);
    return () => clearTimeout(t);
  }, [navigate, qc]);

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "linear-gradient(135deg, #f0fdf4, #ecfdf5)",
    }}>
      <div style={{
        background: "white", borderRadius: 20, padding: "48px 56px", textAlign: "center",
        boxShadow: "0 8px 40px rgba(0,0,0,0.08)", maxWidth: 440,
      }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}>🎉</div>
        <h1 style={{ margin: "0 0 8px", color: "#1e293b", fontSize: 24, fontWeight: 800 }}>
          You're subscribed!
        </h1>
        <p style={{ margin: "0 0 24px", color: "#64748b", fontSize: 15 }}>
          Your plan has been activated. Redirecting you to settings…
        </p>
        <div style={{
          width: "100%", height: 4, background: "#f1f5f9", borderRadius: 2, overflow: "hidden",
        }}>
          <div style={{
            height: "100%", background: "linear-gradient(90deg, #1e3a8a, #00c9a7)",
            borderRadius: 2, animation: "progress 3s linear forwards",
          }} />
        </div>
        <style>{`
          @keyframes progress { from { width: 0% } to { width: 100% } }
        `}</style>
        <button
          onClick={() => navigate("/settings?tab=usage")}
          style={{
            marginTop: 20, padding: "10px 24px", borderRadius: 8, border: "none",
            background: "linear-gradient(135deg, #1e3a8a, #00c9a7)", color: "white",
            fontWeight: 700, fontSize: 14, cursor: "pointer",
          }}
        >
          Go to Settings now
        </button>
      </div>
    </div>
  );
}
